import ng from 'angular';

export const ACCOUNT_ACTIVATION_ROUTES = [
    {
        name: 'account-activation',
        state: {
            data: {
                authenticate: false
            },
            resolve: {
                token: () => {
                    return '';
                }
            },
            url: '/account-activation',
            views: {
                'wrapper@': {
                    template: `<template-account-activation
                                    token="$resolve.token"
                                ></template-account-activation>`
                }
            }
        }
    },
    {
        name: 'account-activation.token',
        state: {
            data: {
                authenticate: false
            },
            resolve: {
                token: ($stateParams: ng.ui.IStateParamsService) => {
                    return $stateParams.token;
                }
            },
            url: '/{token}',
            views: {
                'wrapper@': {
                    template: `<template-account-activation
                                    token="$resolve.token"
                                ></template-account-activation>`
                }
            }
        }
    },
    {
        name: 'account-activation.token.cancel',
        state: {
            abstract: true,
            url: '/cancel'
        }
    },
    {
        name: 'account-activation.token.cancel.stripe',
        state: {
            resolve: {
                token: ($stateParams: ng.ui.IStateParamsService) => {
                    return $stateParams.token;
                },
                paymentId: ($stateParams: ng.ui.IStateParamsService) => {
                    return $stateParams.billingApiPaymentAccountId;
                }
            },
            url: '/stripe?{billingApiPaymentAccountId}',
            views: {
                'wrapper@': {
                    template: `<template-account-activation
                                    token="$resolve.token"
                                    payment-id="$resolve.paymentId"
                                    action="cancel"
                                ></template-account-activation>`
                }
            }
        }
    },
    {
        name: 'account-activation.token.commit',
        state: {
            abstract: true,
            url: '/commit'
        }
    },
    {
        name: 'account-activation.token.commit.stripe',
        state: {
            data: {
                authenticate: false
            },
            resolve: {
                token: ($stateParams: ng.ui.IStateParamsService) => {
                    return $stateParams.token;
                },
                paymentId: ($stateParams: ng.ui.IStateParamsService) => {
                    return $stateParams.billingApiPaymentAccountId;
                }
            },
            url: '/stripe?{billingApiPaymentAccountId}',
            views: {
                'wrapper@': {
                    template: `<template-account-activation
                                    action="commit"
                                    token="$resolve.token"
                                    payment-id="$resolve.paymentId"
                                ></template-account-activation>`
                }
            }
        }
    },
];
